module.exports = __webpack_public_path__ + "static/img/煙波蘇澳.047d4a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/煙波蘇澳.png?20181011
// module id = tYue
// module chunks = 1